/**
 * Holistic Vitalis - Bug Fixes
 * Fixes: masterInput.dispatchEvent, popup close, cart qty buttons, consent script
 * Date: 2026-04-01
 */
(function() {
  'use strict';

  /* ================================================================
   * FIX 1: masterInput.dispatchEvent is not a function
   * The variant picker tries to call dispatchEvent on an element
   * that may not exist or isn't a proper DOM element.
   * This patches the CustomEvent dispatch to fail silently.
   * ================================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    // Patch all variant picker forms to ensure masterInput is valid
    document.querySelectorAll('[id^="selected-variant-id-"]').forEach(function(input) {
      if (input && !input._hvPatched) {
        input._hvPatched = true;
        // Ensure the input has a proper form reference
        var formId = input.getAttribute('form');
        if (formId) {
          var form = document.getElementById(formId);
          if (!form) {
            // Create a hidden form if missing
            form = document.createElement('form');
            form.id = formId;
            form.style.display = 'none';
            document.body.appendChild(form);
          }
        }
      }
    });
  });

  // Global error handler for the specific masterInput error
  window.addEventListener('error', function(e) {
    if (e.message && e.message.indexOf('masterInput.dispatchEvent') !== -1) {
      e.preventDefault();
      return true;
    }
  });

  /* ================================================================
   * FIX 2: Shopify customerPrivacy.marketingAllowed undefined
   * The consent banner script runs before Shopify.customerPrivacy
   * is initialized. This provides a safe fallback.
   * ================================================================ */
  if (typeof window.Shopify === 'undefined') {
    window.Shopify = {};
  }
  if (!window.Shopify.customerPrivacy) {
    window.Shopify.customerPrivacy = {
      marketingAllowed: function() { return true; },
      analyticsProcessingAllowed: function() { return true; },
      preferencesProcessingAllowed: function() { return true; },
      saleOfDataAllowed: function() { return true; },
      shouldShowBanner: function() { return false; },
      getTrackingConsent: function() { return 'no_interaction'; },
      setTrackingConsent: function() {},
      currentVisitorConsent: function() {
        return {
          marketing: 'yes',
          analytics: 'yes',
          preferences: 'yes',
          sale_of_data: 'yes'
        };
      }
    };
  }

  /* ================================================================
   * FIX 3: Popup / Modal close button improvements
   * - Increase touch targets on close buttons
   * - Ensure pointer-events work
   * - Fix z-index stacking
   * ================================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    // Enhance all dialog close buttons
    var closeButtons = document.querySelectorAll('.hdt-dialog-btn__close, [action-close]');
    closeButtons.forEach(function(btn) {
      // Ensure minimum touch target
      btn.style.minWidth = '44px';
      btn.style.minHeight = '44px';
      btn.style.display = 'inline-flex';
      btn.style.alignItems = 'center';
      btn.style.justifyContent = 'center';
      btn.style.pointerEvents = 'auto';
      btn.style.cursor = 'pointer';
      btn.style.zIndex = '100';
      btn.style.position = 'absolute';

      // Add touch event as fallback for click
      btn.addEventListener('touchend', function(e) {
        e.preventDefault();
        btn.click();
      }, { passive: false });
    });

    // Also fix exit popup overlay click-to-close
    var overlays = document.querySelectorAll('.hdt-modal-exit__overlay, .hdt-dialog-modal__overlay');
    overlays.forEach(function(overlay) {
      overlay.style.pointerEvents = 'auto';
      overlay.addEventListener('touchend', function(e) {
        var closeBtn = this.parentElement.querySelector('.hdt-dialog-btn__close, [action-close]');
        if (closeBtn) closeBtn.click();
      });
    });
  });

  /* ================================================================
   * FIX 4: Cart quantity buttons - increase touch targets
   * ================================================================ */
  function fixCartQuantityButtons() {
    var qtyButtons = document.querySelectorAll(
      '.hdt-quantity-cart-item button, ' +
      '.hdt-quantity__button, ' +
      'button.is--minus, ' +
      'button.is--plus'
    );
    qtyButtons.forEach(function(btn) {
      btn.style.minWidth = '44px';
      btn.style.minHeight = '44px';
      btn.style.display = 'inline-flex';
      btn.style.alignItems = 'center';
      btn.style.justifyContent = 'center';
      btn.style.cursor = 'pointer';
      btn.style.touchAction = 'manipulation';
    });
  }

  // Run on load and when cart drawer opens
  document.addEventListener('DOMContentLoaded', fixCartQuantityButtons);

  // Watch ONLY the cart drawer element for open/close — not the entire body
  // (Watching body with subtree:true causes MutationObserver → DOM mutation → MutationObserver
  //  infinite loops that freeze the main thread and stop scroll from working)
  document.addEventListener('DOMContentLoaded', function() {
    var cartDrawer = document.querySelector('#hv-cart-drawer, .hv-cart-drawer, #CartDrawer, hdt-cart-drawer');
    if (cartDrawer) {
      var observer = new MutationObserver(function(mutations) {
        var opened = mutations.some(function(m) {
          return m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'open');
        });
        if (opened) fixCartQuantityButtons();
      });
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class', 'open']
      });
    }
    // Also re-run when cart:open fires
    document.addEventListener('cart:open', fixCartQuantityButtons);
  });

  /* ================================================================
   * FIX 5: Payment icons in cart — make non-clickable look obvious
   * Users rage-click Visa/Amex/PayPal icons thinking they're buttons
   * ================================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    var paymentIcons = document.querySelectorAll(
      '.hdt-mini-cart__payment img, ' +
      '.hdt-mini-cart__payment svg, ' +
      '.payment-icon, ' +
      '[class*="payment"] img'
    );
    paymentIcons.forEach(function(icon) {
      icon.style.pointerEvents = 'none';
      icon.style.cursor = 'default';
    });
  });


  /* ================================================================
   * FIX 6: Block sitewide profityi bundle-builder redirect
   * The profityi.com app injects a script via content_for_header that
   * redirects ALL pages to /pages/mix-match-sale. This interceptor
   * blocks window.location.href assignments that point to the
   * mix-match-sale page when the visitor is NOT already on that page.
   * ================================================================ */
  (function() {
    var MIX_MATCH_PATH = '/pages/mix-match-sale';
    
    // Only apply the guard if we are NOT already on the mix-match-sale page
    if (window.location.pathname === MIX_MATCH_PATH) return;
    
    // Intercept location.href assignments via a descriptor override
    try {
      var _realHref = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
      if (_realHref && _realHref.set) {
        Object.defineProperty(Location.prototype, 'href', {
          get: _realHref.get,
          set: function(url) {
            // Block any redirect to mix-match-sale from non-mix-match-sale pages
            if (typeof url === 'string' && url.indexOf(MIX_MATCH_PATH) !== -1) {
              console.warn('[HV] Blocked profityi sitewide redirect to mix-match-sale:', url);
              return;
            }
            _realHref.set.call(this, url);
          },
          configurable: true
        });
      }
    } catch (err) {
      // Fallback: monitor location changes via MutationObserver if descriptor override fails
      console.warn('[HV] Location override failed, using fallback:', err);
    }
    
    // Also intercept window.location.assign and window.location.replace
    try {
      var _origAssign = window.location.assign.bind(window.location);
      window.location.assign = function(url) {
        if (typeof url === 'string' && url.indexOf(MIX_MATCH_PATH) !== -1) {
          console.warn('[HV] Blocked profityi redirect (assign):', url);
          return;
        }
        _origAssign(url);
      };
    } catch(e) {}
    
    try {
      var _origReplace = window.location.replace.bind(window.location);
      window.location.replace = function(url) {
        if (typeof url === 'string' && url.indexOf(MIX_MATCH_PATH) !== -1) {
          console.warn('[HV] Blocked profityi redirect (replace):', url);
          return;
        }
        _origReplace(url);
      };
    } catch(e) {}
  })();



  /* ================================================================
   * FIX 7: Prevent orphaned scroll-lock on mix-match page
   * html[scroll-lock]{overflow:hidden} fires when any Shopify dialog
   * opens. If a dialog opens and closes incorrectly (newsletter, cart,
   * exit popup), scroll is permanently disabled.
   * This observer watches for scroll-lock on <html> and removes it
   * after 300ms if no <dialog open> is visible.
   * ================================================================ */
  (function() {
    var html = document.documentElement;
    var _clearTimer;
    function clearOrphanedScrollLock() {
      clearTimeout(_clearTimer);
      _clearTimer = setTimeout(function() {
        if (html.hasAttribute('scroll-lock')) {
          var openDialogs = document.querySelectorAll('dialog[open]');
          var visibleDialogs = Array.prototype.filter.call(openDialogs, function(d) {
            var r = d.getBoundingClientRect();
            return r.width > 0 && r.height > 0;
          });
          if (visibleDialogs.length === 0) {
            html.removeAttribute('scroll-lock');
            html.classList.remove('no-scroll');
            document.body.style.overflow = '';
          }
        }
      }, 300);
    }

    var lockObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'scroll-lock' || m.attributeName === 'class') {
          clearOrphanedScrollLock();
        }
      });
    });

    document.addEventListener('DOMContentLoaded', function() {
      lockObserver.observe(html, {
        attributes: true,
        attributeFilter: ['scroll-lock', 'class']
      });
      // Also clear on any scroll attempt (emergency recovery)
      window.addEventListener('touchstart', function() {
        if (html.hasAttribute('scroll-lock')) clearOrphanedScrollLock();
      }, { passive: true });
    });
  })();

})();